// SnpWrapper.js
import React, { useState, useEffect } from "react";
import {
    useDispatch,
    useSelector } from "react-redux";
import { Snackbar } from "../ui";
import { NotificationContainer,
    NotificationManager } from "react-notifications";
import ConfirmDialog from "./ConfirmDialog";
import Loader from "./loader/Loader";
import {
    setGlobalErrorHandler,
    snpAxios,
    } from "./api"; // import both
import {
  INVALIDBILL,
  FAILED,
  NULLDATA,
  ROLEERROR,
  ACCESSDENIED,
  SHOPNOTACCESSERROR,
  SESSIONEXPIRED,
  FIELD_EMPTY,
  VALIDITYEXPIREDERR,
  isEmpty,
  test_environment_mode,
  setLogout,
  INITIAL_SHOP_HASH,
  CartDets,
  LOGOUT,
  offline_enable
} from "../../constants/constant";
import { setActiveShopHash, setCartType } from "../../actions";

const SnpWrapper = ({ children }) => {
    const storeApiUrl = useSelector(
        (state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL
    );
    const dispatch = useDispatch();

    const [loader, setLoader] = useState(false);
    const [isLogout, setIsLogout] = useState(false);
    const [utils, setUtils] = useState({
        showDialog: false,
        subTitle: "",
        btName: "Login Again!",
    });
    const [snackbarUtils, setSnackbarUtils] = useState({
        snackbarOpen: false,
        snackbarMsg: "",
    });

    // set global error handler ONCE
    useEffect(() => {
        setGlobalErrorHandler(onError);
    }, []);


    // useEffect(() => {
    //         //Mounted
    //         printInfoLog("SnpWrapper", "useEffect");
    //     }, [storeApiUrl])

    const onLogout = () => {
        setLoader(false);
        sessionStorage.removeItem("componentIndex");
        sessionStorage.removeItem("carInitialState");
        setLogout();
        dispatch(setCartType(CartDets.All));
        dispatch(setActiveShopHash(INITIAL_SHOP_HASH));
        setIsLogout(true);
    };

    const handleLogout = async () => {
        const logouturl = storeApiUrl.BACKEND_BASE_URL + LOGOUT;
        const data = { jcJson: { value_1: "apiTokenHere" } };
        setLoader(true);
        try {
            await snpAxios.post(logouturl, data);
            onLogout();
        } catch {
            onLogout();
        }
    };

    // centralized error handler (called by interceptor)
    const onError = (response, errSts, errorMsg) => {
        let msg = "";
        if (errSts === INVALIDBILL) {
            msg = isEmpty(errorMsg) ? "Invalid Bill" : errorMsg;
            NotificationManager.error(
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{msg}</p>);
        } else if (errSts === FAILED) {
            NotificationManager.error(
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{isEmpty(errorMsg) ? "Failed" : errorMsg}</p>);
            if (response) {
                return { throw: false, data: response };
            }
            msg = isEmpty(errorMsg) ? "Failed to send/request data" : errorMsg;
        } else if (errSts === NULLDATA) {
            NotificationManager.error(
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{isEmpty(errorMsg) ? "Unexpected Request! Contact SNP Admin" : errorMsg}</p>);
            msg = isEmpty(errorMsg) ? "Empty Request" : errorMsg;
        } else if (errSts === ROLEERROR) {
            NotificationManager.warning(
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{isEmpty(errorMsg) ? "This Request is not allowed to you , ask your owner" : errorMsg}</p>);
            msg = isEmpty(errorMsg) ? "This Request is not allowed to you , ask your owner" : errorMsg;
        } else if (errSts === ACCESSDENIED) {
            setUtils({
                ...utils,
                showDialog: true,
                subTitle: isEmpty(errorMsg) ? "Some Internal Problem. Login Again" : errorMsg

            });
            msg = isEmpty(errorMsg) ? "Invalid user" : errorMsg;
        } else if (errSts === SHOPNOTACCESSERROR) {
            setUtils({
                ...utils,
                showDialog: true,
                subTitle: isEmpty(errorMsg) ? "Not Allowed to access this shop.\nLogin Again" : errorMsg

            })
            msg = isEmpty(errorMsg) ? "Invalid shop owner" : errorMsg;
        } else if (errSts === SESSIONEXPIRED) {
            setUtils({
                ...utils,
                showDialog: true,
                subTitle: isEmpty(errorMsg) ? "Session Expired.Login Again!" : errorMsg

            })
            msg = isEmpty(errorMsg) ? "Session Expired" : errorMsg;
        } else if (errSts === FIELD_EMPTY) {
            if (test_environment_mode) {
                NotificationManager.warning(
                    <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{isEmpty(errorMsg) ? "Missing Fields!Contact SNP Admin" : errorMsg}</p>);
            } else {
                NotificationManager.warning(
                    <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{"Some Key Not Available!\nContact SNP Admin"}</p>);
            }
            msg = isEmpty(errorMsg) ? "Missing Fields" : errorMsg;
        } else if (errSts === VALIDITYEXPIREDERR) {
            NotificationManager.warning(
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{isEmpty(errorMsg) ? "Your Billing Software is expired.Please recharge" : errorMsg}</p>);
            msg = isEmpty(errorMsg) ? "Your Billing Software is expired" : errorMsg;
        } else {
            msg = isEmpty(errorMsg) ? "Internal Error Try Again" : errorMsg;
            NotificationManager.error(
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{msg}</p>);

        }
        const error = new Error(msg);
        error.code = errSts;
        return { reason: true, data: error };
    }

    const closeSnackbar = () =>
        setSnackbarUtils({ ...snackbarUtils, snackbarOpen: false });

    const onLogoutWindowClose = () => {
        window.opener = null;
        window.open(window.location, "_self");
        window.close();
    };

    const handleLoginWindowOpen = () => {
        window.open(`${window.location.origin}/#/login`, "_self");
        window.location.reload();
        //onLogoutWindowClose();
    };

    return (
        <>
            {loader ? (
                <Loader />
            ) : isLogout ? offline_enable ? onLogoutWindowClose() : handleLoginWindowOpen() : (
                <div>
                    <NotificationContainer />
                    <Snackbar
                        open={snackbarUtils.snackbarOpen}
                        message={snackbarUtils.snackbarMsg}
                        autoHideDuration={3000}
                        onClose={closeSnackbar}
                    />
                    <ConfirmDialog isOpen={utils.showDialog}
                        title={""}
                        subTitle={utils.subTitle}
                        negativeReq={false}
                        positiveReq={true}
                        outsideClickedDismiss={false}
                        positiveAction={utils.btName}
                        onSubmit={handleLogout}
                    />
                    {children}
                </div>
            )}
        </>
    );
};

export default SnpWrapper;
